<wlx-tabs>
  <wlx-tab title="{{ 'invoices.invoice-builder.invoice-details' | translate | titlecase }}" *ngIf="!isNewMemberInvoice">
    <div>
      <wl-invoice-details [invoice]="invoice"></wl-invoice-details>
    </div>
  </wlx-tab>
  <wlx-tab title="{{ 'invoices.invoice-builder.line-items' | translate | titlecase }}">
    <div>
      <wl-invoice-line-items-list [invoice]="invoice" [allUsers]="allUsers" [allRevenueItems]="allRevenueItems"
        [billingDto]="billingDto" [isNewMemberInvoice]="isNewMemberInvoice"></wl-invoice-line-items-list>
    </div>
  </wlx-tab>
  <wlx-tab title="{{ 'invoices.invoice-builder.payment' | translate | titlecase }}">
    <div>
      <wl-invoice-payment [invoice]="invoice" [creditCardPayment]="creditCardPayment"
        [isNewMemberInvoice]="isNewMemberInvoice" [paymentTypeInvalid]="paymentTypeInvalid"
        [allRevenueItems]="allRevenueItems" (paymentTypeSelected)="onPaymentTypeSelected()"></wl-invoice-payment>
    </div>
  </wlx-tab>
  <wlx-tab title="{{ 'invoices.invoice-builder.line-item-adjustments' | translate | titlecase }}">
    <div>
      <wl-invoice-adjustment #lineItemAdjustments [invoice]="invoice" [allRevenueItems]="allRevenueItems"
        [isLineItemAdjustments]="true" [adjustmentHeader]="invoice.LineItemAdjustmentHeader"></wl-invoice-adjustment>
    </div>
  </wlx-tab>
  <wlx-tab title="{{ 'invoices.invoice-builder.payment-adjustments' | translate | titlecase }}">
    <div>
      <wl-invoice-adjustment #paymentAdjustments [invoice]="invoice" [isLineItemAdjustments]="false"
        [adjustmentHeader]="invoice.PaymentAdjustmentHeader"></wl-invoice-adjustment>
    </div>
  </wlx-tab>
  <wlx-tab [hidden]="invoice?.InvoiceHeader.InvoiceNum == 0"
    *wlAccessControl="{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 }"
    title="{{ 'invoices.invoice-builder.delete-invoice' | translate | titlecase }}">
    <div>
      <wl-invoice-delete [invoice]="invoice"></wl-invoice-delete>
    </div>
  </wlx-tab>
</wlx-tabs>
